module.exports = __webpack_public_path__ + "static/media/uva2.f5cce554.png";